import Header from "../../components/Header/Header";
import iconTelWhite from "../../assets/icon_tel_wh.svg";
import { Accordion, AccordionItem } from "@szhsin/react-accordion";
import useReactGASend from "../../hooks/useReactGASend";
import { GiCheckMark } from "react-icons/gi";
import React from "react";


const common = [
  {
    title: "포토카드는 어떻게 구매하나요?",
    content: "포토카드는 SSG랜더스필드 키오스크에서 구매 가능합니다. \n\n[ICON:check]키오스크 위치 : 3번 게이트 옆 랜더스 포토카드존 & 외야 7번 게이트 옆 포토카드존 \n- 운영 기간 : 정규 시즌 홈경기\n- 운영시간 : 게이트 오픈~경기 종료 후 30분\n- 이용요금 : 포토카드 5,000원\n- 결제방법 : 카드 결제\n\n※   포토카드는 카드 결제만 가능합니다." ,
    reference: "",
  },
  {
    title: "구매한 유니폼이 불량이에요.",
    content:
      "유니폼 구매 후 교환/불량 문의는 각 굿즈샵 고객센터를 통해 상담 가능합니다. \n\n[ICON:check]랜더스샵 by hyungji \n- 문의전화 : 1811-9156 \n\n[ICON:check]랜더스샵 by emart \n- 고객센터 : 1577-3419 \n\n[ICON:check]랜더스샵 by LINE FRIENDS \n- 고객센터 : 1588-3819 \n\n[ICON:check]온라인샵 by core \n- 고객센터 : 070-5224-1969 \n\n ※   아래 링크를 통해 각 굿즈샵 고객센터로 연결 가능합니다.",
    reference:
      "",
    buttons: [
      { 
        title: "랜더스샵 by hyungji",
        link: "tel:1811-9156",
        isPhoneLink: true
      },
      { 
        title: "랜더스샵 by emart",
        link: "tel:1577-3419",
        isPhoneLink: true
      },
      { 
        title: "랜더스샵 by LINE FRIENDS",
        link: "tel:1588-3819",
        isPhoneLink: true
      },
      { 
        title: "랜더스샵 by core",
        link: "tel:070-5224-1969",
        isPhoneLink: true
      }
    ]
  },
  {
    title: "열 부착 마킹은 어디에서 하나요?",
    content:
      "구매한 유니폼 및 마킹지는 각 구매처에서 열 부착 마킹이 가능합니다. \n\n[ICON:check]랜더스샵 by hyungji \n- 위치 : 랜더스필드 1층 1루 방면 스타벅스 게이트 옆 \n- 고객센터 : 1811-9156 \n\n[ICON:check]랜더스샵 by emart \n- 위치 : 랜더스필드 외야 GATE 7 방면 (외부에 위치) \n- 고객센터 : 1577-3419 \n\n[ICON:check]랜더스샵 by LINE FRIENDS \n- 위치 : 랜더스필드 1층 3루 GATE 6 방면 \n- 고객센터 : 1588-3819 \n\n ※ 열 부착 마킹은 각 구매처 별로 가능합니다. \n[SPACE]*예시) 형지샵 구매 유니폼은 형지샵 마킹처에서 가능 \n※   열 부착 마킹은 홈경기 굿즈샵 운영 시간 내 가능합니다. \n※   열 부착 마킹 관련 자세한 문의는 각 굿즈샵 고객센터로 문의 부탁드립니다.",
    reference: ""
  },
  {
    title: "유니폼 배송은 언제 오나요?",
    content:
      "유니폼/굿즈 판매 및 배송은 각 운영사에서 관리되고 있어 구매하신 굿즈샵 고객센터를 통해 확인 가능합니다. \n\n[ICON:check]랜더스샵 by hyungji \n- 문의전화 : 1811-9156 \n\n[ICON:check]랜더스샵 by emart\n- 고객센터 : 1577-3419 \n\n[ICON:check]랜더스샵 by LINE FRIENDS\n- 고객센터 : 1588-3819 \n\n[ICON:check]온라인샵 by core\n- 고객센터 : 070-5224-1969\n\n ※   아래 링크를 통해 각 굿즈샵 고객센터로 연결 가능합니다.",
    reference: "",
    buttons: [
      { 
        title: "랜더스샵 by hyungji",
        link: "tel:1811-9156",
        isPhoneLink: true
      },
      { 
        title: "랜더스샵 by emart",
        link: "tel:1577-3419",
        isPhoneLink: true
      },
      { 
        title: "랜더스샵 by LINE FRIENDS",
        link: "tel:1588-3819",
        isPhoneLink: true
      },
      { 
        title: "랜더스샵 by core",
        link: "tel:070-5224-1969",
        isPhoneLink: true
      }
    ]
  },
];

const ICON_MAP = {
  check: <GiCheckMark className="inline-block mr-1"/>
}

const formatText = (text) => {
  return text.split("\n").map((line, index) => {
    const elements = [];

    let rest = line;

    // 1. 앞에 [SPACE]가 몇 개 있는지 계산
    const spaceMatches = rest.match(/^(\[SPACE])+/);
    if (spaceMatches) {
      const count = spaceMatches[0].match(/\[SPACE\]/g).length;
      for (let i = 0; i < count; i++) {
        elements.push(<span key={`space-${i}`} className="pl-2" />);
      }
      rest = rest.replace(/^(\[SPACE\])+/,"").trim();
    }

    // 2. 아이콘 처리
    const iconMatch = rest.match(/\[ICON:(.+?)\]/);
    if (iconMatch) {
      const iconKey = iconMatch[1];
      elements.push(
        <span key="icon" className="inline-flex items-baseline pt-1">
          {ICON_MAP[iconKey]}
        </span>
      );
      rest = rest.replace(iconMatch[0], "").trim();
    }

    // 3. 텍스트
    elements.push(<span key="text">{rest}</span>);

    return (
      <div key={index} className="flex items-start">
        {elements}
        {index < text.split("\n").length - 1 && <br />}
      </div>
    );
  });
};

export const AccordionItemComponent = ({
  item,
  index,
}) => (
  <AccordionItem
    key={index}
    itemKey={index}
    className="mb-2"
    header={({state}) => 
      <div className={`flex items-center w-full pb-2 text-lg font-semibold text-gray-950 border border-[#D1D5DB] p-2.5 bg-white text-left ${state.isEnter ? 'rounded-bl-none rounded-br-none rounded-tl-[30px] rounded-tr-[30px] border-none' : 'rounded-full'}`}>
        <span
          className={`inline-flex items-center justify-center p-3 h-10 bg-black shadow-md rounded-full text-white text-2xl font-semibold shrink-0 mr-2`}
        >
          Q
        </span>
        {item.title}
      </div>
    }
  >
  {({state}) => 
    <div className={`p-6 border rounded-3xl border-[#D1D5DB] bg-white ${state.isEnter && 'rounded-tl-none rounded-tr-none border-none mt-[-10px]'}`}>
      <p className="font-medium text-gray-950">{formatText(item.content)}</p>
      {item.buttons && (
        <div className="flex justify-center flex-col">
          {item.buttons.map(button => (
            <LinkItem
              title={button.title}
              url={button.link}
              styles={"mx-6"}
            />
          ))}
        </div>
      )}
    </div>
  } 
  </AccordionItem>
);


export const LinkButton = ({
  url,
  className,
  imgSrc,
  altText,
  buttonText,
  onClick,
}) => (
  <a
    onClick={onClick}
    href={url}
    className={className}
  >
    <span className="shrink-0">
      <img src={imgSrc} alt={altText} />
    </span>
    <span className="flex-1 text-center">{buttonText}</span>
  </a>
);

export const LinkItem = ({ title, url, isPhoneLink, onClick, styles }) => (
  <li className="pt-4 list-none">
    <a
      onClick={onClick}
      href={url}
      target={isPhoneLink ? undefined : "_blank"}
      rel={isPhoneLink ? undefined : "noopener noreferrer"}
      className={`flex items-center bg-[#FFFFFF] ${
        isPhoneLink ? "gap-4" : ""
      } justify-center h-12 rounded-[16px] ${
        isPhoneLink ? "border-2" : "border"
      } border-[#FFA2A2] text-[#CE152D] font-semibold ${styles}`}
    >
      {isPhoneLink && <img alt="상담원 연결 전화 아이콘" />}
      {title}
    </a>
  </li>
);


const GoodsPage = () => {
  const { makeEventTrackFn } = useReactGASend();
  const trackButtonClick = (title) => {
    makeEventTrackFn({
      category: "event",
      action: title,
    });
  };

  return (
    <section className="p-hasHeader">
      <Header title="유니폼/굿즈" />
      <div className="bg-white p-7 rounded-3xl mb-6 font-medium text-base mt-2 text-gray-950">
        <div>굿즈 구매/배송 및 교환/불량 문의는 해당 굿즈샵 고객센터를 통해 상담 가능합니다.</div>
        <br />
        <div className="flex items-center"><GiCheckMark className="inline-flex items-baseline mr-1"/> 오프라인 굿즈샵(인천 SSG랜더스필드 내 위치)</div>
        <div>• 랜더스샵 by hyungji</div>
        <div>- 위치 : 1층 1루 방면 스타벅스 게이트 옆(내부)</div>
        <div>- 운영시간 : 게이트 오픈시간~경기종료 후 30분</div>
        <br />
        <div>• 랜더스샵 by emart</div>
        <div>- 위치 : 외야 게이트(GATE 7) 방면 (외부)</div>
        <div>- 운영시간 : 게이트 오픈시간~경기종료 후 30분</div>
        <br />
        <div>• 라인 프렌즈샵</div>
        <div>- 위치 : GATE 6 방면 (내부)</div>
        <div>- 운영시간 : 게이트 오픈시간~경기종료 후 30분</div>
        <br />
        <div className="flex items-center"><GiCheckMark className="inline-flex items-baseline mr-1"/> 온라인 굿즈샵</div>
        <div>• 온라인샵 by hyungji (1811-9156)</div>
        <div>• 온라인샵 by emart (1577-3419)</div>
        <div>• 온라인샵 by LINE FRIENDS (1588-3819)</div>
        <div>• 온라인샵 by core (070-5224-1969)</div>
        <br />
        <div>※    하단 접속 링크를 통해 각 온라인샵으로 이동 가능합니다.</div>
        <LinkItem
          title="온라인샵 by hyungji"
          url="https://store.ssglanders.com/"
          onClick={() => trackButtonClick("굿즈_온라인샵 by hyungji")}
        />
        <LinkItem
          title="온라인샵 by emart"
          url="https://landers.mfamily.ssg.com/"
          onClick={() => trackButtonClick("굿즈_온라인샵 by emart")}
        />
        <LinkItem
          title="온라인샵 by LINE FRIENDS"
          url="https://m.smartstore.naver.com/ssglanders_friends_shop/category/929ba081c6184265b1bb63cd4239fd63?cp=1"
          onClick={() => trackButtonClick("굿즈_온라인샵 by LINE FRIENDS")}
        />
        <LinkItem
          title="온라인샵 by core"
          url="https://landerscorestore.co.kr/"
          onClick={() => trackButtonClick("굿즈_온라인샵 by core")}
        />
      </div>

      <Accordion transition transitionTimeout={250}>
        {common.map((item, index) => (
          <AccordionItemComponent
            key={index}
            item={item}
            index={index}
          />
        ))}
      </Accordion>

      <div className="flex flex-col items-center mt-10 bg-white p-5 rounded-3xl justify-center w-full ">
        <div className="text-base font-medium text-[#4A5565] pb-2 flex text-center justify-center">추가적인 도움이 필요하신가요?</div>
        <LinkButton
          url="tel:032-455-2600"
          className="flex items-center justify-between w-36 h-9 bg-brand-secondary rounded-[30px] text-white px-6 py-6 text-sm font-medium mb-1.5"
          imgSrc={iconTelWhite}
          buttonText="전화상담"
          onClick={() => trackButtonClick("굿즈_전화상담")}
        />
      </div>
    </section>
  );
};

export default GoodsPage;
